import _extends from "@babel/runtime/helpers/extends";
import { DEFAULTS } from "./defaultSettings";
import { nodeViewDecorators } from "./nodeViewDecorators";
import { MENTION_TYPE } from "./types";
var pluginMentions = function pluginMentions(config) {
  return {
    config: _extends({}, DEFAULTS.config, config),
    type: MENTION_TYPE,
    nodeViewDecorators: nodeViewDecorators
  };
};
export { pluginMentions };
import "@wix/ricos/css/plugin-mentions-viewer.global.css";